import { render, staticRenderFns } from "./VacationsControl.vue?vue&type=template&id=65d1e1e6&scoped=true"
import script from "./VacationsControl.vue?vue&type=script&lang=js"
export * from "./VacationsControl.vue?vue&type=script&lang=js"
import style0 from "./VacationsControl.vue?vue&type=style&index=0&id=65d1e1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1e1e6",
  null
  
)

export default component.exports